import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e) {
  return e && ("function" == typeof e.on || "function" == typeof e.addEventListener);
}

function r(r, t, n) {
  if (!e(r)) throw new TypeError("target is not a Evented or EventTarget object");
  if ("on" in r) return r.on(t, n);

  if (Array.isArray(t)) {
    var _e = t.slice();

    var _iterator = _createForOfIteratorHelper(_e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t2 = _step.value;
        r.addEventListener(_t2, n);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return {
      remove: function remove() {
        var _iterator2 = _createForOfIteratorHelper(_e),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t = _step2.value;
            r.removeEventListener(_t, n);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };
  }

  return r.addEventListener(t, n), {
    remove: function remove() {
      r.removeEventListener(t, n);
    }
  };
}

function t(t, n, o) {
  if (!e(t)) throw new TypeError("target is not a Evented or EventTarget object");
  if ("once" in t) return t.once(n, o);
  var i = r(t, n, function (e) {
    i.remove(), o.call(t, e);
  });
  return {
    remove: function remove() {
      i.remove();
    }
  };
}

function n(e, t, n) {
  var o = !1;
  var i = r(e, t, function (r) {
    o || n.call(e, r);
  });
  return {
    resume: function resume() {
      o = !1;
    },
    pause: function pause() {
      o = !0;
    },
    remove: function remove() {
      i.remove();
    }
  };
}

var o = {
  Win: "Meta",
  Scroll: "ScrollLock",
  Spacebar: " ",
  Down: "ArrowDown",
  Left: "ArrowLeft",
  Right: "ArrowRight",
  Up: "ArrowUp",
  Del: "Delete",
  Apps: "ContextMenu",
  Esc: "Escape",
  Multiply: "*",
  Add: "+",
  Subtract: "-",
  Decimal: ".",
  Divide: "/"
};

function i(_ref) {
  var e = _ref.key;
  return o[e] || e;
}

export { i as eventKey, o as ieKeyNormalizationMap, e as isEventTarget, r as on, t as once, n as pausable };